import './App.css';

import Landingpage from './component/landingpage';
import Navbar from './component/navbar';
import Footer from './component/footer';

function App() {
  return (
    <>
      <Navbar />
      <Landingpage />
      <Footer />
    </>
  );
}

export default App;
